import React, { useEffect, useRef, useState } from "react";
import "./styles/bounceproof.css";
import BlueButton from "../components/BlueButton";

// icons import form lucide react icons
import { Plus, Minus, ChevronDown } from "lucide-react";

// img imports
import emailList from "../images/emailList.svg";
import verifyEveryAdd from "../images/verifyEveryAddress.svg";
import readyToSend from "../images/readyToSend.svg";
import gridcard1 from "../images/catchingdetection.svg";
import gridcard2 from "../images/emailblocking.svg";
import gridcard3 from "../images/smtp.svg";
import gridcard4 from "../images/domaincheck.svg";
import gridcard5 from "../images/bounceshield.svg";
import gridcard6 from "../images/campaigntrack.svg";
import bouncesheetimg from "../images/bounce-excel-sheet.svg";
import bouncesheetimg1 from "../images/bounce-excel-sheet1.svg";
import bounceprooflogo from "../images/bounceprooflogo.svg";
import productcardimg1 from "../images/bounceproofproductcardimg1.svg";
import productcardimg2 from "../images/bounceproofproductcardimg2.svg";
import productcardimg3 from "../images/bounceproofproductcardimg3.svg";
import productcardimg4 from "../images/bounceproofproductcardimg4.svg";
import productcardimg5 from "../images/bounceproofproductcardimg5.svg";

import ProductCard from "../components/product-card-animation/ProductCard";
import QuestionsTab from "../components/QuestionsTab";
import TextCarosul from "../components/TextCarosul";
import BounceFooter from "../components/BounceFooter";
import leftArrow from "../images/arrow-left.svg";

import apidochighlighted from "../images/apidochighlighted.svg";
import newsletter from "../images/blogposthighlighted.svg";
import blogposthighlighted from "../images/newsletter-footer-hightlighted.svg";
import { toast } from "sonner";
import axios from "axios";
import top1 from "../images/top1.svg";
import CustomAnimatedCards from "../components/CustomAnimatedCards";
import AccountModal from "../components/AccountModal";
// import GlassPane from "../components/GlassPane";

const bounceInboxesData = [
  {
    stepCount: 1,
    stepHeading: "Upload Your List",
    stepDesc:
      "Paste a single email, upload your file, or connect your google sheet to our bulk email checker.",
    imgSrc: emailList,
  },
  {
    stepCount: 2,
    stepHeading: "Verify Every Address",
    stepDesc:
      "Our real-time email validator runs multiple checks, tagging results as Safe, Risky, Reject, or Unknown.",
    imgSrc: verifyEveryAdd,
  },
  {
    stepCount: 3,
    stepHeading: "Send With Confidence",
    stepDesc:
      "Export a clean, verified list and hit higher inbox rates with ease.",
    imgSrc: readyToSend,
  },
];
const pricingTiers = [
  { limit: 5, price: 0, label: "Free", off: "" },
  { limit: 5000, price: 0.14, label: "0.14 Cent", off: "25% OFF" },
  { limit: 10000, price: 0.12, label: "0.12 Cent", off: "35% OFF" },
  { limit: 20000, price: 0.102, label: "0.102 Cent", off: "45% OFF" },
  { limit: 50000, price: 0.08, label: "0.08 Cent", off: "55% OFF" },
  { limit: 100000, price: 0.06, label: "0.06 Cent", off: "65% OFF" },
  { limit: 1000000, price: 0.04, label: "0.04 Cent", off: "75% OFF" },
];
const monthlyPricingTiers = [
  { limit: 20000, price: 0.092, before: "0.102 Cent", label: "0.092 Cent" },
  { limit: 50000, price: 0.075, before: "0.084 Cent", label: "0.075 Cent" },
  { limit: 100000, price: 0.058, before: "0.065 Cent", label: "0.058 Cent" },
  { limit: 1000000, price: 0.042, before: "0.046 Cent", label: "0.042 Cent" },
];
const FaqData = [
  {
    ques: "What is BounceProof?",
    ans:
      "BounceProof is an email verification tool that helps you clean lists, reduce bounce rates and protect your domain reputation.",
  },
  {
    ques: "How accurate is the verification?",
    ans:
      "BounceProof delivers up to 95% accuracy by running multiple checks including syntax, MX records, disposable emails, spam traps and SMTP validation.",
  },
  {
    ques: "Do my credits expire?",
    ans:
      "No. Unlike other bulk email verifiers, BounceProof credits never expire. You can roll them into your next campaign anytime.",
  },
  {
    ques: "Can I use BounceProof without technical skills?",
    ans:
      "Yes. BounceProof is a self-serve email validation tool. Upload your list, click verify and download your cleaned file — no setup needed.",
  },
  {
    ques: "Can I verify emails directly in Google and Excel Sheets?",
    ans:
      "Yes. With our Google and Excel Sheets integration, you can run bulk email checks directly in your sheet without exporting CSV files.",
  },
  {
    ques: "What happens to invalid or risky emails?",
    ans:
      "BounceProof categorizes every email as Safe, Risky, Reject or Unknown so you can decide which ones to keep or remove.",
  },
  {
    ques: "Does BounceProof give me analytics on past checks and bulk uploads?",
    ans:
      "Yes. Every verification run is stored with analytics, so you can track performance, monitor bounce trends, and keep a history of all bulk uploads for smarter decisions.",
  },
];
const activeCardsData = [
  {
    id: 1,
    title: "Pick a range, click verify, see results instantly.",
    content: "",
    activeImage: apidochighlighted,
    inactiveImage: "/images/apidoc.svg",
  },
  {
    id: 2,
    title: "Stay in your flow; no exports, no switching tools.",
    content: "",
    activeImage: blogposthighlighted,
    inactiveImage: "/images/bigblogpost.svg",
  },
  {
    id: 3,
    title: "Get clean, campaign-ready lists right inside Sheets.",
    content: "",
    activeImage: newsletter,
    inactiveImage: "/images/newsletter-footer.svg",
  },
];
const productCardData = [
  {
    id: 1,
    imgUrl: productcardimg1,
    apiName: "Spend Less on Verification",
    successMsg: "Only pay for the emails you check. Save up to 85% instantly.",
  },
  {
    id: 2,
    imgUrl: productcardimg2,
    apiName: "Stop Bounces Before They Hurt",
    successMsg: "Protect your domain reputation with 95+% verified accuracy.",
  },
  {
    id: 3,
    imgUrl: productcardimg3,
    apiName: "Never Lose Your Credits",
    successMsg: "Credits never expire; use them in your next campaign anytime.",
  },
  {
    id: 4,
    imgUrl: productcardimg4,
    apiName: "Get Results in Seconds",
    successMsg: "Upload, verify, and download a campaign-ready list instantly.",
  },
  {
    id: 5,
    imgUrl: productcardimg5,
    apiName: "Simplify Your Workflow",
    successMsg: "Three simple steps: upload, verify, export. No setup needed.",
  },
];

const blockedDomains = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com"];

function BounceProof() {
  const [payMonthly, setPayMonthly] = useState(false);
  const [apisCount, setApisCount] = useState(10000);
  const [monthlyApisCount, setMonthlyApisCount] = useState(1000000);
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [showResponse, setShowResponse] = useState(false);
  const [verificationResult, setVerificationResult] = useState(null);
  const [hiding, setHiding] = useState(false);
  const dropdownRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isMobile = window.innerWidth < 768;

  const activeTier =
    pricingTiers.find((t) => apisCount <= t.limit) ||
    pricingTiers[pricingTiers.length - 1];

  const monthlyActiveTier =
    monthlyPricingTiers.find((t) => monthlyApisCount <= t.limit) ||
    monthlyPricingTiers[monthlyPricingTiers.length - 1];

  // step 3: calculate payable amount in INR
  const payableINR = (apisCount * activeTier.price) / 100;
  const monthlyPayableINR = (monthlyApisCount * monthlyActiveTier.price) / 100;

  // convert INR → USD
  const payable = payableINR.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  const monthlyPayable = monthlyPayableINR.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  const handleScrollToFooter = () => {
    const footer = document.getElementById("bounce-footer");
    if (footer) {
      footer.scrollIntoView({ behavior: "smooth" });
    }
  };

  // useEffects
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleBackToForm = () => {
    setShowResponse(false);
    setHiding(false);
    setVerificationResult(null);
    setEmail("");
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Please enter your email to fetch results.");

    if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/.test(
        email
      )
    ) {
      toast.error("Oops! That email doesn’t seem right. Try again?");
      return;
    }

    const domain = email.split("@")[1].toLowerCase();

    if (blockedDomains.includes(domain)) {
      toast.error("Personal emails aren’t allowed. Try using your work email.");
      return;
    }

    setLoading(true);
    try {
      const baseUrl = process.env.REACT_APP_TAMPERPROOF_URL;
      const endpoint = "/dashboard/bounce-proof/";
      const url = `${baseUrl}${endpoint}`;

      const headers = {
        "Content-Type": "application/json",
      };

      const res = await axios.post(
        url,
        { email: email, user_email: email },
        { headers }
      );

      setVerificationResult({
        email: email,
        status: res.data.result,
        reason: res.data.reason,
        domain: res.data.domain,
        mxFound: res.data.mx_found,
        firstName: res.data.first_name,
        lastName: res.data.last_name,
        companyName: res.data.company_name,
      });

      setShowResponse(true);
    } catch (error) {
      toast.error(
        error?.response?.data?.detail ||
          "We’re facing a tiny glitch. Hang tight and retry."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bounce-main">
      <div className="bounce-banner-section">
        <div className="bounce-headings-container">
          <h1 className="herosection-heading-global">Email Campaigns</h1>
          <h3 className="herosection-subheading-global">
            Start with BounceProof{" "}
          </h3>
        </div>
        <p className="bounce-banner-section-text">
          The most trusted email verification tool to clean lists, improve
          deliverability, and reach more inboxes.
        </p>
        <div className="bounce-banner-form-container">
          <form
            className="bounce-banner-form"
            onSubmit={(e) => handleVerify(e)}
          >
            <h3>
              Enter an email or upload your list to get instant verification
              results
            </h3>
            <div className="bounce-banner-form-input">
              <input
                type="email"
                placeholder="johndoe@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <BlueButton
                type="submit"
                text="Verify Now"
                styles={{ textWrap: "nowrap" }}
                loading={loading}
              />
            </div>
          </form>
          <p className="instant-bounce">
            Get Instant Results | 💰 5 Free Credits For Now
          </p>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "1rem",
            }}
          >
            <button
              style={{
                width: isMobile ? "80%" : "fit-content",
                fontSize: "1rem",
                color: "#6D2FEC",
                border: "1px solid #A0E100",
                backgroundImage:
                  "radial-gradient(circle at 50% 50%, #DFFF8E, #AFF500 91%)",
              }}
              onClick={() => setIsModalOpen(true)}
              className="verify-now-btn"
            >
              Create an Account
            </button>
          </div>

          {/* FORM RESPONSE */}
          {/* <div className="bounce-banner-form-container"> */}
          {showResponse && (
            <div
              className={`bounce-banner-form-response ${
                hiding ? "bouncehide" : ""
              }`}
            >
              <div
                role="button"
                className="bounce-banner-form-response-back-btn"
                onClick={handleBackToForm}
              >
                <img
                  src={leftArrow}
                  alt=""
                  style={{ width: "1.5rem", height: "1.5rem" }}
                />
                Back
              </div>
              <center
                style={{
                  color: "#242834",
                  fontFamily: "nohemi",
                  fontWeight: "500",
                  fontSize: isMobile ? "1rem" : "1.25rem",
                  lineHeight: isMobile ? "1.5rem" : "2rem",
                }}
              >
                {verificationResult?.status}{" "}
                {verificationResult?.status === "Safe"
                  ? "✅"
                  : verificationResult?.status === "Reject"
                  ? "❌"
                  : verificationResult?.status === "Risky"
                  ? "⚠"
                  : "❓"}
              </center>
              <div className="bounce-banner-form-response-data">
                <div
                  style={{ paddingBottom: "1rem" }}
                  className="bounce-banner-form-response-data-list"
                >
                  <span>Email</span>
                  <span>{verificationResult?.email}</span>
                </div>
                <div className="bounce-form-datapoints-parent">
                  <div className="bounce-banner-form-response-data-list">
                    <span>Reason</span>
                    <span>{verificationResult?.status}</span>
                  </div>
                  <div className="bounce-banner-form-response-data-list">
                    <span>Domain</span>
                    <span>{verificationResult?.domain}</span>
                  </div>
                  <div className="bounce-banner-form-response-data-list">
                    <span>MX Found</span>
                    <span>{verificationResult?.mxFound}</span>
                  </div>
                  <div className="bounce-banner-form-response-data-list">
                    <span>First Name</span>
                    <span>{verificationResult?.firstName}</span>
                  </div>
                  <div className="bounce-banner-form-response-data-list">
                    <span>Last Name</span>
                    <span>{verificationResult?.lastName}</span>
                  </div>
                  <div className="bounce-banner-form-response-data-list">
                    <span>Company Name</span>
                    <span>{verificationResult?.companyName}</span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* </div> */}
        </div>
      </div>
      {/* section 2 Three Steps to Inbox-Ready Emails*/}
      <div className="bounce-inbox-containers">
        <h1>
          Three Steps to <span style={{ color: "#6D2FEC" }}>Inbox-Ready </span>
          Emails
        </h1>

        <div className="bounce-inbox-feature-group">
          {bounceInboxesData.map((el, index) => (
            <BounceInboxComponent {...el} key={index} isIndex={index === 0} />
          ))}
        </div>
      </div>

      {/* section 3 */}
      <img src={top1} alt="" className="active" />
      <div style={{ background: "#fff" }}>
        <div className="bounce-grid-layout">
          <div className="bounce-grid-headings">
            <h1>
              The Checks Your <span style={{ color: "#B9FE0B" }}>Emails</span>{" "}
              Wish They Had
            </h1>
            <p>Catch every bad email before it ruins your campaign.</p>
          </div>
          <div className="masonry-grid">
            {/* card-1 */}
            <div
              style={{ border: "1px solid #D6F7AB", background: "#F4FFE3" }}
              className="api-card  id-card grid-item-1-1"
            >
              <div className="id-card-text">
                <div className="image-text">
                  <h3>Catch-All Detection</h3>
                </div>
                <p>
                  Avoid domains that accept every email but never actually
                  deliver.
                </p>
              </div>

              <img src={gridcard1} alt="" style={{ borderRadius: "1.25rem" }} />
            </div>
            {/* card-2 */}
            <div
              style={{ border: "1px solid #FFEAE9", background: "#FFE7E6" }}
              className="api-card ocr-card grid-item-1-2"
            >
              <div className="ocr-card-text">
                <div className="image-text">
                  <h3>Disposable Email Blocking</h3>
                </div>
                <p>
                  Remove risky one-time inboxes that waste credits and hurt
                  sender score.
                </p>
              </div>
              <img src={gridcard2} alt="" style={{ borderRadius: "1rem" }} />
            </div>
            {/* card-3 */}
            <div
              style={{ border: "1px solid #DAE3FF", background: "#E8EEFF" }}
              className="api-card ocr-card grid-item-2-1"
            >
              <div className="ocr-card-text">
                <div className="image-text">
                  <h3>SMTP & MX Validation</h3>
                </div>
                <p>
                  Confirm that each mailbox and server really exists before you
                  send.
                </p>
              </div>

              <img src={gridcard3} alt="" style={{ borderRadius: "1rem" }} />
            </div>
            {/* card-4 */}
            <div
              style={{ border: "1px solid #FFF0D2", background: "#FFFAF0" }}
              className="api-card  id-card grid-item-2-2"
            >
              <div className="id-card-text">
                <div className="image-text">
                  <h3>Syntax & Domain Check</h3>
                </div>
                <p>
                  Instantly flag typos, invalid formats, and dead domains in
                  your list.
                </p>
              </div>

              <img src={gridcard4} alt="" style={{ borderRadius: "1.25rem" }} />
            </div>
            {/* card-5 */}
            <div
              style={{ border: "1px solid #FFEB86", background: "#FFFBE7" }}
              className="api-card  id-card grid-item-3-1"
            >
              <div className="id-card-text">
                <div className="image-text">
                  <h3>Bounce & Spam-Trap Shield</h3>
                </div>
                <p>
                  Detect addresses that could trigger blocks or blacklist your
                  domain.
                </p>
              </div>

              <img src={gridcard5} alt="" style={{ borderRadius: "1.25rem" }} />
            </div>
            {/* card-6 */}
            <div
              style={{ border: "1px solid #F9E1FF", background: "#FBE8FF" }}
              className="api-card ocr-card grid-item-3-3"
            >
              <div className="ocr-card-text">
                <div className="image-text">
                  <h3>Campaign Tracking</h3>
                </div>
                <p>
                  For smarter sending, keep complete record of your past
                  verifications with our email validation tool.
                </p>
              </div>
              <img src={gridcard6} alt="" />
            </div>
          </div>
          {/* <img src={bottom1} alt="" className="active-bottom" /> */}
        </div>
      </div>
      {/* section 4 */}
      <div className="bounce-sheets">
        <div className="bounce-sheets-headings">
          <h1 className="bounce-h1">
            Bring Email Verification to{" "}
            <span style={{ color: "#6D2FEC" }}>Google Sheets</span>
          </h1>
          <p className="bounce-p">
            No downloads, no CSVs, no switching tabs. BounceProof works directly
            in Google Sheets, making it the simplest bulk email checker for
            teams. Verify emails right where you already manage your campaigns.
          </p>
        </div>
        <img src={bouncesheetimg} alt="" className="active1" />
        <img src={bouncesheetimg1} alt="" className="active2" />
        <div className="bounce-animatied-cards">
          <div className="bounce-mobile-none">
            <CustomAnimatedCards
              cards={activeCardsData}
              cardWidth={isMobile ? "auto" : "20vw"}
            />
          </div>
          <div className="bounce-animatied-cards1">
            <img src={apidochighlighted} alt="frame" />
            <p>Pick a range, click verify, see results instantly.</p>
          </div>
          <div className="bounce-animatied-cards2">
            <img src="/images/bigblogpost.svg" alt="frame" />
            <p>Stay in your flow; no exports, no switching tools.</p>
          </div>
          <div className="bounce-animatied-cards2">
            <img src="/images/newsletter-footer.svg" alt="frame" />
            <p>Get clean, campaign-ready lists right inside Sheets.</p>
          </div>
        </div>
      </div>
      {/* section 5 why choose bounce proof */}
      {/* <div style={{ background: "#fff" }}>
        <img src={top2} alt="" className="bounce-top" />
      </div> */}

      <div className="bounce-main-quality">
        <div className="bounce-quality">
          <div className="bounce-quality-headings">
            <h1 style={{ color: "white" }} className="bounce-h1">
              Why Choose <span style={{ color: "#B9FE0B" }}>BounceProof</span>{" "}
              Over Others
            </h1>
            <p style={{ color: "white" }} className="bounce-p">
              We’ve designed BounceProof to be the most reliable email
              verification tool for growing businesses.
            </p>
          </div>
          <div
            className="bounce-quality-content"
            style={{ overflowY: "hidden" }}
          >
            <ProductCard
              backgroundColor={"#5723C1"}
              cardsData={productCardData}
            />
            <div className="bounce-main-logo">
              <img
                src={bounceprooflogo}
                alt="bounceproof logo"
                className="bounceproof_logo"
              />
            </div>
          </div>
        </div>
      </div>
      {/* section 6 Bounce Pricing */}
      <div className="bounce-pricing-container">
        <h1 className="bounce-h1">
          <span style={{ color: "#6D2FEC" }}>Pricing</span> Tailored only for
          You!
        </h1>
        <div className="bounce-pricing-data-container">
          <div className="bounce-pricing-headings">
            <div className="bounce-pricing-btns">
              <button
                className={`bounce-paycredit-btn ${
                  !payMonthly ? "bounce-paycredit-btn-active" : ""
                }`}
                onClick={() => setPayMonthly(false)}
              >
                Pay Per Credit
              </button>

              <button
                className={`bounce-monthly-btn ${
                  payMonthly ? "bounce-monthly-btn-active" : ""
                }`}
                onClick={() => setPayMonthly(true)}
              >
                Monthly Plans
                <BadgeComponent text={"10% OFF"} />
              </button>
            </div>
            <p className="bounce-p">
              {payMonthly
                ? "10% Discount on per-credit click"
                : "Amount varies as per Credits and Emails"}
            </p>
          </div>
          {payMonthly ? (
            <div className="bounce-pricing-table">
              <div className="bounce-pricing-table-card">
                <div className="bounce-pricing-table-card-section-1">
                  <h3>Select Your Custom Plan</h3>
                  <div
                    className="bounce-pricing-table-card-input-section"
                    ref={dropdownRef}
                  >
                    <input
                      type="text"
                      disabled={true}
                      value={monthlyApisCount.toLocaleString()}
                    />
                    <span
                      role="button"
                      className={`bounce-icon`}
                      onClick={() => setIsOpen((p) => !p)}
                    >
                      <ChevronDown
                        style={{
                          transition: "transform 0.3s ease",
                          transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                        }}
                      />
                    </span>

                    {isOpen && (
                      <div className="bounce-custum-dropdown">
                        {monthlyPricingTiers.map((tier) => {
                          const isActive =
                            monthlyActiveTier.limit === tier.limit;
                          return (
                            <div
                              key={tier.limit}
                              style={{ cursor: "pointer" }}
                              onClick={() => setMonthlyApisCount(tier.limit)}
                              className={`bounce-pricing-table-data ${
                                isActive ? "active-tier" : ""
                              }`}
                            >
                              <span>{tier.limit.toLocaleString()}</span>
                              <span>
                                <span
                                  style={{
                                    marginRight: ".5rem",
                                    textDecoration: "line-through",
                                    color: "#4F525D",
                                    fontSize: "14px",
                                    lineHeight: "24px",
                                  }}
                                >
                                  {tier.before}
                                </span>
                                {tier.label}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
                <div className="bounce-pricing-table-card-section-2">
                  <h1>$ {monthlyPayable}</h1>
                  <p>Total Payable Amount</p>
                </div>
                <div className="bounce-pricing-table-card-section-3">
                  <button onClick={handleScrollToFooter}>Buy Now</button>
                  <p>
                    Over 1 Million Emails? <a href="#">Contact Us</a>
                  </p>
                </div>
              </div>
              <div className="bounce-pricing-table-table">
                <h3>Select Plan</h3>
                <div className="bounce-pricing-table-data">
                  <span>Emails Upto </span>
                  <span>Amount per Credit</span>
                </div>
                {monthlyPricingTiers.map((tier) => {
                  const isActive = monthlyActiveTier.limit === tier.limit;
                  return (
                    <div
                      key={tier.limit}
                      className={`bounce-pricing-table-data ${
                        isActive ? "active-tier" : ""
                      }`}
                    >
                      <span>{tier.limit.toLocaleString()}</span>
                      <span>
                        <span
                          style={{
                            marginRight: ".5rem",
                            textDecoration: "line-through",
                            color: "#4F525D",
                            fontSize: "14px",
                            lineHeight: "24px",
                          }}
                        >
                          {tier.before}
                        </span>
                        {tier.label}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="bounce-pricing-table">
              <div className="bounce-pricing-table-card">
                <div className="bounce-pricing-table-card-section-1">
                  <h3>Enter your Custom Credits here</h3>
                  <div className="bounce-pricing-table-card-input-section">
                    <span
                      role="button"
                      className="bounce-icon"
                      onClick={() =>
                        setApisCount((prev) => {
                          const num = prev === "" ? 0 : Number(prev);
                          return num - 1;
                        })
                      }
                    >
                      <Minus />
                    </span>

                    <input
                      type="number"
                      value={apisCount}
                      onChange={(e) => {
                        const val = e.target.value;
                        setApisCount(
                          val === "" ? "" : Math.max(Number(val), 0)
                        );
                      }}
                    />

                    <span
                      role="button"
                      className="bounce-icon"
                      onClick={() =>
                        setApisCount((prev) => {
                          const num = prev === "" ? 0 : Number(prev);
                          return num + 1;
                        })
                      }
                    >
                      <Plus />
                    </span>
                  </div>
                  {apisCount <= 2000 && (
                    <p style={{ color: "red" }}>
                      Select atleast 2000 Credits to Buy
                    </p>
                  )}
                </div>
                <div className="bounce-pricing-table-card-section-2">
                  <h1>$ {payable}</h1>
                  <p>Total Payable Amount</p>
                </div>
                <div className="bounce-pricing-table-card-section-3">
                  <button onClick={handleScrollToFooter}>Buy Now</button>
                  <p>
                    Over 1 Million Emails? <a href="#">Contact Us</a>
                  </p>
                </div>
              </div>
              <div className="bounce-pricing-table-table">
                <h3>Pay Per Credit</h3>
                <div className="bounce-pricing-table-data">
                  <span>Emails Upto </span>
                  <span>Amount per Credit</span>
                </div>
                {pricingTiers.map((tier) => {
                  const isActive = activeTier.limit === tier.limit;
                  return (
                    <div
                      key={tier.limit}
                      className={`bounce-pricing-table-data ${
                        isActive ? "active-tier" : ""
                      }`}
                      onClick={() => {
                        setApisCount(tier.limit);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <span>{tier.limit.toLocaleString()}</span>
                      <span>
                        {tier.label}
                        {tier.off && (
                          <span
                            style={{
                              background: "#B6FF00",
                              marginLeft: ".2rem",
                            }}
                          >
                            {tier.off}
                          </span>
                        )}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
      {/* section 7 Bounce FAQ */}
      <div className="faq-wrapper">
        <h1 className="bounce-h1">
          <span style={{ color: "#6D2FEC" }}>Answers</span> That Deliver, Like
          Your <span style={{ color: "#6D2FEC" }}>Emails</span> Should
        </h1>
        <div className="faq-questions-tab">
          {FaqData.map((el, idx) => (
            <QuestionsTab {...el} key={idx} />
          ))}
        </div>
      </div>
      {/* section 8 text carosul */}
      <TextCarosul />
      {/* section 9 Footer */}
      <BounceFooter />
      <AccountModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        product="bounceproof"
      />
    </div>
  );
}

export default BounceProof;

const BounceInboxComponent = ({
  stepCount,
  stepHeading,
  stepDesc,
  imgSrc,
  isIndex,
}) => {
  return (
    <div className="bounce-inbox-component-container">
      <div className="bounce-inbox-component-headings">
        <p>Step {stepCount}</p>
        <p>{stepHeading}</p>
        <p>{stepDesc}</p>
      </div>

      <div className="bounce-inbox-image-wrapper">
        <img src={imgSrc} alt="" />
      </div>
    </div>
  );
};

const BadgeComponent = ({ text }) => {
  return <div className="bounce-badge">{text}</div>;
};
